import React, { useState } from 'react';
import { Modal, Steps, message, Button } from 'antd';
import Step1 from './steps/Step1';
import Step2 from './steps/Step2';
import Step3 from './steps/Step3';
import Step4 from './steps/Step4';
import Step5 from './steps/Step5';

const { Step } = Steps;

export default function WizardComponent({ open, onClose }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [step1Selections, setStep1Selections] = useState([]);
  const [step2Selections, setStep2Selections] = useState([]);
  const [step3Conditions, setStep3Conditions] = useState([]);
  const [step4Conditions, setStep4Conditions] = useState([]);

  const resetWizard = () => {
    setCurrentStep(0);
    setStep1Selections([]);
    setStep2Selections([]);
    setStep3Conditions([]);
    setStep4Conditions([]);
  };

  const handleCancel = () => {
    resetWizard();
    onClose();
  };

  const next = () => {
    if (currentStep === 0 && step1Selections.length === 0) {
      return message.error('Selecciona al menos una opción en el paso 1');
    }

    /*
    if (currentStep === 1 && step2Selections.length === 0) {
      return message.error('Selecciona al menos una opción en el paso 2');
    }
    */
    
    setCurrentStep(currentStep + 1);
  };

  const prev = () => setCurrentStep(currentStep - 1);

  const handleFinish = () => {
    /*
    if (step3Conditions.length === 0) {
      return message.error('Agrega al menos una condición para continuar');
    }
    */

    console.log('Envío final:', {
      step1Selections,
      step2Selections,
      step3Conditions,
      step4Conditions,
    });
    message.success('Audiencia creada');
    handleCancel();
  };

  const steps = [
    {
      title: 'Tipo de usuario',
      content: <Step1 value={step1Selections} onChange={setStep1Selections} />,
    },
    {
      title: 'Segmento',
      content: <Step2 value={step2Selections} onChange={setStep2Selections} />,
    },
    {
      title: 'Comportamiento',
      content: (
        <Step3
          value={step3Conditions}
          onChange={setStep3Conditions}
        />
      ),
    },    
    {
      title: 'Localización',
      content: (
        <Step5
          value={step4Conditions}
          onChange={setStep4Conditions}
        />
      ),
    }
  ];

  const isNextDisabled =
    (currentStep === 0 && step1Selections.length === 0) 
    //||(currentStep === 1 && step2Selections.length === 0)
    ;

  const isPrevDisabled = currentStep === 0;
  const isFinishDisabled = false;//currentStep !== steps.length - 1 || step3Conditions.length === 0;

  return (
    <Modal
      title="Crear audiencia"
      open={open}
      onCancel={handleCancel}
      footer={null}      
      width="100%"
      style={{ maxWidth: 700 }}      
    >
      <Steps current={currentStep} style={{ marginBottom: 24 }}>
        {steps.map((step) => (
          <Step key={step.title} title={step.title} />
        ))}
      </Steps>

      <div>{steps[currentStep].content}</div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
        <Button style={{ marginRight: 8 }} onClick={prev} disabled={isPrevDisabled}>
          Anterior
        </Button>

        {currentStep === steps.length - 1 ? (
          <Button type="primary" onClick={handleFinish} disabled={isFinishDisabled}>
            Finalizar
          </Button>
        ) : (
          <Button type="primary" onClick={next} disabled={isNextDisabled}>
            Siguiente
          </Button>
        )}
      </div>
    </Modal>
  );
}
